/** Pure helpers for the Personal digest page (kept out of the page module so
 * react-refresh sees only a component there, and so they unit-test cleanly). */

/** "just now" / "12 min ago" / "6h ago" / "3d ago" for a timestamp. */
export function relativeAge(iso: string, now: Date = new Date()): string {
  const ms = now.getTime() - new Date(iso).getTime();
  if (!Number.isFinite(ms) || ms < 0) return 'just now';
  const mins = Math.round(ms / 60_000);
  if (mins < 2) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.round(mins / 60);
  if (hours < 36) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

/** First word of a display name, for the friendly copy. */
export function firstName(display: string): string {
  return display.trim().split(/\s+/)[0] || display;
}
